import {createElement, useEffect, useRef} from 'react';
import DOMPurify from 'dompurify';

interface Props {
  /** 렌더링할 요소의 태그 이름 */
  as?: keyof HTMLElementTagNameMap;
  /** html 문법을 포함한 문자열 */
  html: string;
  /** 렌더링할 요소의 클래스 이름 */
  className?: string;
  /** html 내부에 있는 요소에 대한 속성 설정 */
  selectorProps?: {
    [selector: string]: {
      [attributeName: string]: string | ((event: any) => void);
    };
  };
}

const InnerHTMLRenderer = ({html, className, as = 'div', selectorProps}: Props) => {
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (containerRef.current && selectorProps) {
      Object.entries(selectorProps).forEach(([selector, attributes]) => {
        const elements = containerRef.current?.querySelectorAll(selector);
        if (elements) {
          elements.forEach((element) => {
            Object.entries(attributes).forEach(([attrName, attrValue]) => {
              if (typeof attrValue === 'function' && attrName.startsWith('on')) {
                const eventName = attrName.substring(2).toLowerCase();
                element.addEventListener(eventName, attrValue);
              } else {
                element.setAttribute(attrName, attrValue as string);
              }
            });
          });
        }
      });
    }
  }, []);

  const createMarkup = () => {
    return {
      __html: DOMPurify.sanitize(html, {
        ADD_TAGS: ['a'],
        ADD_ATTR: ['href'],
        ALLOW_UNKNOWN_PROTOCOLS: true
      })
    };
  };
  return createElement(as, {
    ref: containerRef,
    className,
    dangerouslySetInnerHTML: createMarkup()
  });
};

export default InnerHTMLRenderer;
